import React, { useState } from "react";
import { classNames } from "../../helpers";
import { useSelector } from "react-redux";
import { loadingState } from "../../redux/reducers/loadingReducer";
import { ExclamationCircleIcon } from '@heroicons/react/16/solid'
import { Combobox, ComboboxButton, ComboboxInput, ComboboxOption, ComboboxOptions } from "@headlessui/react";
import useGoogleAutocomplete from "react-google-autocomplete/lib/usePlacesAutocompleteService";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/24/outline";
import { MapPinIcon } from "@heroicons/react/24/solid";

export default function TwLocationInput(props) {
  const loadingReduxState = useSelector(loadingState);

  const {
    placesService,
    placePredictions,
    getPlacePredictions,
    isPlacePredictionsLoading,
  } = useGoogleAutocomplete({
    apiKey: process.env.REACT_APP_GOOGLE_MAPS_API,
  });
  const { name = "", label = "", className = "", errors = {}, error = "", leftIcon = "", rightIcon = "", wrapperClassName = "w-full sm:w-full sm:max-w-sm md:max-w-lg" } = props
  let inputProps = { ...props }
  delete inputProps.wrapperClassName
  delete inputProps.leftIcon
  delete inputProps.rightIcon
  delete inputProps.errors
  delete inputProps.defaultLocationSelect
  delete inputProps.onLocationSelect
  let inputLableClass = "text-black/[0.6]"
  let inputClass = "text-gray-900 outline-gray-300 placeholder:text-gray-400 hover:outline-indigo-bz focus-within:outline-indigo-bz"
  if (name && errors[name] && errors[name] !== "") {
    props = {
      ...props,
      error: props.errors[name]
    };
  }
  if (props.error && props.error !== "") {
    inputLableClass = "text-red-600"
    inputClass = "text-red-900 outline-red-300 placeholder:text-red-300 focus-within:outline-red-600"
  }

  if (inputProps.disabled && inputProps.disabled !== undefined) {
    inputClass += " !bg-gray-200 disabled:bg-gray-200"
  }

  const [query, setQuery] = useState('')
  const [address, setAddress] = useState({});

  const postAddress = (placeDetails, placeGeocode, coordinates) => {
    let city =
      placeGeocode.address_components[
        placeGeocode.address_components.length - 3
      ]?.long_name || "";
    const address = {
      addressType: "current",
      address: placeDetails.description,
      description: placeDetails.description,
      houseNumber: placeDetails.structured_formatting.main_text,
      city: placeGeocode.address_components[
        placeGeocode.address_components.length - 3
      ]?.long_name || "",
      zip: placeGeocode.address_components[
        placeGeocode.address_components.length - 1
      ].types.find((type) => type.startsWith("postal"))
        ? placeGeocode.address_components[
          placeGeocode.address_components.length - 1
        ]?.long_name || ""
        : "",
      addressName: city ? city : "Business Address",
      location: {
        type: "Point",
        coordinates,
      },
    };
    setAddress(address);
    if (props.onLocationSelect) {
      props.onLocationSelect(address, { placeDetails, placeGeocode, coordinates });
    }
  };

  React.useEffect(() => {
    if (props.defaultLocationSelect) {
      setAddress(props.defaultLocationSelect);
    }
  }, [props.defaultLocationSelect]);


  return (
    // <div className="">
    <div className={wrapperClassName}>
      {label && (<label htmlFor={name} className={classNames("block text-sm/6 font-medium", inputLableClass)}>
        {label}
      </label>)}
      <div className="mt-2">
        <Combobox
          as="div"
          value={address}
          className={classNames("rounded-xl bg-input-bz px-2 outline outline-1 -outline-offset-1 outline-gray-300 hover-within:outline hover-within:outline-2 hover-within:-outline-offset-2 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 ", inputClass)}
          onChange={(e) => {
            if (e?.place_id) {
              placesService.getDetails(
                {
                  placeId: e.place_id,
                },
                (placeDetails) => {
                  const lat = placeDetails.geometry.location.lat();
                  const lng = placeDetails.geometry.location.lng();
                  const coordinates = [lat, lng];
                  postAddress(e, placeDetails, coordinates);
                }
              );
              setQuery('')
            }
          }}
        >
          <div className="relative rounded-lg px-6">

            {leftIcon && (
              <ComboboxButton className="absolute inset-y-0 left-0 flex items-center rounded-l-md px-2 md:px-3 focus:outline-none">{leftIcon}</ComboboxButton>
            )}
            <ComboboxInput
              {...inputProps}
              className={classNames("bg-transparent w-full min-w-0 grow py-4 md:py-5 text-base text-gray-900 placeholder:text-gray-400 focus:outline focus:outline-0 sm:text-sm/6",
                props.error ? "pr-6" : "pr-10",
                leftIcon ? "pl-4" : "pl-10"
              )}
              placeholder={"Select Location"}
              displayValue={(value) => value && (value.description || value?.address)}
              onChange={(e) => {
                getPlacePredictions({ input: e.target.value });
                setQuery(e.target.value);
              }}
            />
            <ComboboxButton className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-0 focus:outline-none">
              <ChevronUpDownIcon className="size-5 text-gray-400" aria-hidden="true" />
            </ComboboxButton>
            {(<ComboboxOptions
              className="absolute z-10 -ml-6 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm"
            >
              {!isPlacePredictionsLoading &&
                placePredictions.map((place, idx) => {
                  return (
                    <ComboboxOption
                      className="group relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 focus:bg-indigo-600 focus:text-white focus:outline-none"
                      key={idx}
                      value={place}
                    >
                      <div className="flex items-center">
                        <MapPinIcon
                          className={classNames(
                            'inline-block size-4 shrink-0 rounded-full',
                          )}
                          aria-hidden="true"
                        />
                        <span className="ml-3 truncate group-data-[selected]:font-semibold">
                          {place.description}
                        </span>
                      </div>
                      <span className={classNames("absolute inset-y-0 right-0  items-center pr-4 text-indigo-600 group-focus:text-white",
                        place.description === query ? "flex" : "hidden"
                      )}>
                        <CheckIcon className="size-5" aria-hidden="true" />
                      </span>
                    </ComboboxOption>
                  );
                })}
            </ComboboxOptions>)}
            {props.error && (<ComboboxButton className="absolute inset-y-0 right-5 flex items-center rounded-r-md px-2 focus:outline-none">
              <ExclamationCircleIcon
                aria-hidden="true"
                className="pointer-events-none col-start-1 row-start-1 size-5 self-center justify-self-end text-red-500 sm:size-4"
              />
            </ComboboxButton>)}
          </div>
        </Combobox>
      </div>
      {props.error && (<p id="email-error" className="mt-2 text-sm text-red-600">
        {props.error}
      </p>)}
    </div>
  );
}
